import Heading from '@zenbusiness/zui/Heading';
import SharedLottieAsset from '@zenbusiness/zui/SharedLottieAsset';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

export default function DepositLoading({ url, text, height, loadCompletedHandler = () => {} }) {
  return (
    <Stack
      alignItems="center"
      aria-label="animation loading"
      height="100%"
      justifyContent="center"
    >
      <Stack
        alignItems="center"
        height={height}
        justifyContent="center"
      >
        <SharedLottieAsset
          onComplete={loadCompletedHandler}
          options={{ loop: true }}
          src={url}
        />
      </Stack>
      <Heading
        family="secondary"
        size="2xl"
        weight="bold"
      >
        {text}
      </Heading>
    </Stack>
  );
}

DepositLoading.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string,
  height: PropTypes.string,
  loadCompletedHandler: PropTypes.func
};
